export default __webpack_public_path__ + "static/media/acceptTick.e69ae08e.svg";